var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "movements-events-combined-table" },
    [
      _c("BaseTable", {
        attrs: {
          title: _vm.title,
          headers: _vm.headers,
          items: _vm.combinedItems,
          loading: _vm.loading,
          "sort-by": _vm.sortBy,
          "sort-desc": _vm.sortDesc,
          "custom-sort": _vm.customSort,
          "search-value": _vm.search,
          "disable-margin-top": ""
        },
        scopedSlots: _vm._u(
          [
            {
              key: "item.icon",
              fn: function(ref) {
                var item = ref.item
                return [_c("EventIcon", { attrs: { event: item } })]
              }
            },
            !_vm.asset || !_vm.asset.id || _vm.showAssetNameColumn
              ? {
                  key: "item.nome_ativo",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.getAssetNameText({ item: item })) +
                            " "
                        )
                      ])
                    ]
                  }
                }
              : null,
            {
              key: "item.operacao",
              fn: function(ref) {
                var item = ref.item
                return [
                  _vm.isMovement(item)
                    ? _c(
                        "div",
                        {
                          staticClass: "d-flex align-items-center az-gap-small"
                        },
                        [
                          _vm._v(" " + _vm._s(item.operacao) + " "),
                          _vm.sugestoesPorLinha[item.id_aplicacao]
                            ? _c("IaSuggestionsPendingBadge", {
                                attrs: {
                                  pendentes:
                                    _vm.sugestoesPorLinha[item.id_aplicacao],
                                  "data-test": "mov-sugestoes-ia"
                                },
                                on: {
                                  revisar: function($event) {
                                    return _vm.$emit("revisar-sugestoes", item)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _vm._v(" " + _vm._s(item.operacao) + " "),
                          _vm.isSplit(item)
                            ? [
                                _c("span", [
                                  _vm._v(
                                    " de " +
                                      _vm._s(item.de) +
                                      ":" +
                                      _vm._s(item.para)
                                  )
                                ])
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                ]
              }
            },
            {
              key: "item.quantidade",
              fn: function(ref) {
                var item = ref.item
                return [
                  _vm._v(" " + _vm._s(_vm.quantityText({ item: item })) + " ")
                ]
              }
            },
            {
              key: "item.valor_unitario",
              fn: function(ref) {
                var item = ref.item
                return [
                  _vm.isProvento(item)
                    ? [_vm._v(" " + _vm._s(item._valorUnitarioText) + " ")]
                    : [_vm._v(" " + _vm._s(_vm.unitPriceText(item)) + " ")]
                ]
              }
            },
            {
              key: "item.valor",
              fn: function(ref) {
                var item = ref.item
                return [
                  _vm.isProvento(item)
                    ? [
                        ["Bonificação (%)"].includes(item.operacao)
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(item.valor) +
                                  "x " +
                                  _vm._s(
                                    item.nome_ativo ||
                                      (_vm.asset && _vm.asset.referencia)
                                  ) +
                                  " "
                              )
                            ]
                          : [_vm._v(" " + _vm._s(item._valorText) + " ")]
                      ]
                    : [_vm._v(" " + _vm._s(item.valor) + " ")]
                ]
              }
            },
            {
              key: "item.origem",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.FORMAT_ORIGEM[item.origem] || item.origem || "-"
                        ) +
                        " "
                    )
                  ])
                ]
              }
            },
            {
              key: "item.action",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-center" },
                    [
                      _vm.isMovement(item) && _vm.shouldShowUnitPriceAlert(item)
                        ? _c(
                            "div",
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { "max-width": "300", left: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              "div",
                                              _vm._g(
                                                _vm._b({}, "div", attrs, false),
                                                on
                                              ),
                                              [
                                                _c("icon-svg", {
                                                  attrs: {
                                                    name: "warning",
                                                    color: _vm.warningColor
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " Para calcular a rentabilidade, é necessário preencher o preço unitário e quantidade desta movimentação. "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("TableRowActions", {
                        attrs: { actions: _vm.getRowActions({ item: item }) }
                      })
                    ],
                    1
                  )
                ]
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }